import {
    WALLET_BTC_BALANCE_ERROR,
    WALLET_BTC_BALANCE_LOAD,
    WALLET_BTC_BALANCE_SUCCESS,
    WALLET_BTC_FEE_ERROR,
    WALLET_BTC_FEE_LOAD,
    WALLET_BTC_FEE_SUCCESS,
    WALLET_BTC_BTCOUT_ERROR,
    WALLET_BTC_BTCOUT_SUBMIT,
    WALLET_BTC_BTCOUT_SUCCESS,
} from '../actionTypes'

import {
    setInfoLocalStorage,
    getInfoLocalStorage
} from '../../utils/api'

import moment from 'moment'

const setStateLocalStorage = getInfoLocalStorage()

const initialState = {
    isLoading: false,
    isLoadingFees: false,
    message: '',
    success: true,
    btcBalance: setStateLocalStorage.btcBalance || 0,
    fees: [],
    feesMessage: '',
    cashSubmit: false,
    cashSuccess: true,
    cashMessage: null
}

export default (state = initialState, action) => {
    switch(action.type) {

        case WALLET_BTC_BALANCE_LOAD:
            return {
                ...state,
                isLoading: true
            }
                    
        case WALLET_BTC_BALANCE_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                message: action.payload.message
            }
        
        case WALLET_BTC_BALANCE_SUCCESS:
            const balanceInfo = {
                btcBalance: action.payload.balance,
                updatedAT: moment()
            }
            console.log("wallet_btc balanceInfo: ", balanceInfo)
            setInfoLocalStorage(balanceInfo)
        
            return {
                ...state,
                isLoading: false,
                success: true,
                btcBalance: action.payload.balance,
                ...balanceInfo
            }

        case WALLET_BTC_FEE_LOAD:
            return {
                ...state,
                isLoadingFees: true
            }
    
        case WALLET_BTC_FEE_ERROR:
            return {
                ...state,
                isLoadingFees: false,
                feesMessage: action.payload.message,
                success: false
            }
    
        case WALLET_BTC_FEE_SUCCESS:
            return {
                ...state,
                isLoadingFees: false,
                fees: action.payload.fees,
                success: true,
                feesMessage: null
            }

        case WALLET_BTC_BTCOUT_ERROR:
            return {
                ...state,
                cashSuccess: false,
                cashSubmit: false,
                cashMessage: action.payload.message
            }
            
        case WALLET_BTC_BTCOUT_SUBMIT:
            return {
                ...state,
                cashSubmit: true
            }
    
        case WALLET_BTC_BTCOUT_SUCCESS:
            return {
                ...state,
                cashSubmit: false,
                cashSuccess: true,
                cashMessage: action.payload.message
            }
            
        default:
            return state
    }
}